import IntlMessageFormat from 'intl-messageformat';
import type { SupportedLocale } from './types';

const intlLocaleMap: Record<SupportedLocale, string> = {
  en: 'en-US',
  lv: 'lv-LV',
};

// Cache IntlMessageFormat instances to avoid recreating on every call
const mfCache = new Map<string, IntlMessageFormat>();

/**
 * Format message with ICU MessageFormat support for plurals, select, etc.
 * Example: "{count, plural, one {# photo} other {# photos}}"
 * Uses caching for performance.
 */
export function formatPlural(
  message: string,
  values: Record<string, any>,
  locale: SupportedLocale = 'en'
): string {
  try {
    const cacheKey = `${intlLocaleMap[locale]}|${message}`;
    let msg = mfCache.get(cacheKey);
    
    if (!msg) {
      msg = new IntlMessageFormat(message, intlLocaleMap[locale]);
      mfCache.set(cacheKey, msg);
    }
    
    return msg.format(values) as string;
  } catch (error) {
    console.warn('[i18n] Plural formatting error:', error, 'Message:', message);
    // Fallback to simple interpolation
    return message.replace(/\{(\w+)\}/g, (_, key) => String(values[key] ?? `{${key}}`));
  }
}

